"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_AUDIT_TRAIL_RESPONSE_EXAMPLE = exports.PATIENT_CLINICAL_WORKFLOW_TIMELINE_RESPONSE_EXAMPLE = exports.PATIENT_CLINICAL_TIMELINE_RESPONSE_EXAMPLE = void 0;
const clinical_common_response_1 = require("./clinical-common.response");
exports.PATIENT_CLINICAL_TIMELINE_RESPONSE_EXAMPLE = [clinical_common_response_1.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE];
exports.PATIENT_CLINICAL_WORKFLOW_TIMELINE_RESPONSE_EXAMPLE = [
    clinical_common_response_1.CLINICAL_WORKFLOW_TIMELINE_ENTRY_RESPONSE_EXAMPLE,
];
exports.CLINICAL_AUDIT_TRAIL_RESPONSE_EXAMPLE = [clinical_common_response_1.AUDIT_LOG_RESPONSE_EXAMPLE];
//# sourceMappingURL=clinical-timeline.response.js.map